import './styled.scss';
import { observer, useLocalObservable } from 'mobx-react';
import Pagination from '../../Pagination/Pagination';
import { useEffect, useState } from 'react';
import ComplexNewsCommonModel from 'common-modules/general/Common/Logic/News/NewsCommon';
import { ResponseHomeNewsList } from 'common-modules/general/API/news/types';
import { toJS } from 'mobx';
import Detail from './Detail';
import NoResultWithLabel from 'common-modules/general/Common/Components/NoResultWithLabel';
import { useHistory } from 'react-router';
import { RoutesString } from 'common-modules/general/Config/routesString';

const News = observer(() => {
  const history = useHistory();
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const { model: mainModel } = useLocalObservable(() => ({ model: new ComplexNewsCommonModel() }));

  useEffect(() => {
    mainModel.getData({});
  }, [mainModel]);

  const getSearchItem = () => {
    if (mainModel) {
      mainModel.getData({ page: currentPage, keyword: searchValue });
      setSearchValue('');
    }
  };

  const handleClickNoticeItem = (data: ResponseHomeNewsList) => {
    history.push(`${RoutesString.SalesNewsDetail}/?id=${data.noUperWrtSral}`);
  };

  const noticeListData = toJS(mainModel.mainData.data?.list);
  const totalCount = mainModel.mainData.data?.totalPage || 0;

  const renderList = () => {
    return (
      noticeListData &&
      noticeListData.map(item => {
        return (
          <ul className="border-list" key={item.noUperWrtSral} onClick={() => handleClickNoticeItem(item)}>
            <li className="tit">{item.sbjtNtcPlte}</li>
            <li className="day">{item.dntRgst}</li>
          </ul>
        );
      })
    );
  };

  // 페이지네이션 내 페이지 변경 시 state 감지
  useEffect(() => {
    if (mainModel) {
      mainModel.getData({ page: currentPage, keyword: searchValue });
    }
  }, [currentPage]);

  return (
    <div className="contents-news">
      <section className="section-wrapper">
        <div className="total-search-input-wrapper">
          <div className="total-search-input-form">
            <div className="input-form">
              <div className="input">
                <input value={searchValue} onChange={e => setSearchValue(e.target.value)} type="text" />
              </div>
              <div className="searchIcon" onClick={getSearchItem}>
                <i aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
        {noticeListData && noticeListData.length > 0 ? (
          <div className="border-wrapper">
            <div className="border-form">{renderList()}</div>
          </div>
        ) : (
          <NoResultWithLabel>결과가 없습니다.</NoResultWithLabel>
        )}
      </section>
      <Pagination limit={10} currentPage={currentPage} setCurrentPage={setCurrentPage} totalCount={totalCount * 10} />
    </div>
  );
});

export default News;
